import {Component, Input} from '@angular/core';
import {UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {DateValidator, StaticCommonValidator} from 'src/app/shared/library/px-ui/px-forms/validators';
import {RegexPatternValidator} from '../../core/validators/regex-pattern.validator';
import {nameValidator} from "../../core/validators/validators";

@Component({
    selector: 'odbs-kind',
    templateUrl: './kind.component.html',
    styleUrls: ['./kind.component.scss'],
})
export class KindComponent {
    @Input()
    formGroup: UntypedFormGroup;

    @Input()
    prefixId = 'ea';

    get kinder() {
        return this.formGroup.get('kinder') as UntypedFormArray;
    }

    static newKindFormGroup() {
        return new UntypedFormGroup({
            kindGeburtsdatum: new UntypedFormControl('', [
                StaticCommonValidator.required,
                DateValidator.valid,
                DateValidator.geburtsdatum,
                RegexPatternValidator.geburtsdatum,
            ]),
            kindVorname: new UntypedFormControl('', [Validators.required, nameValidator]),
            kindAbweichenderNachname: new UntypedFormControl('', nameValidator),
        });
    }

    kindHinzufuegen() {
        this.kinder.push(KindComponent.newKindFormGroup());

        // set focus on next element
        const nextElementId = `${this.prefixId}_kindGeburtsdatum_${this.kinder.length - 1}_inp`;
        setTimeout(() => {
            document.getElementById(nextElementId).focus();
        });
    }

    kindLoeschen(i) {
        this.kinder.removeAt(i);
    }
}
